import { createContext, type ReactNode, useContext, useState } from "react";

type LoginCredentials = {
  email: string;
  password: string;
};

type LoginCredentialsContextType = {
  credentials: LoginCredentials | null;
  setCredentials: (credentials: LoginCredentials | null) => void;
};

const LoginCredentialsContext = createContext<LoginCredentialsContextType | undefined>(undefined);

export const LoginCredentialsProvider = ({ children }: { children: ReactNode }) => {
  const [credentials, setCredentials] = useState<LoginCredentials | null>(null);

  return (
    <LoginCredentialsContext.Provider value={{ credentials, setCredentials }}>
      {children}
    </LoginCredentialsContext.Provider>
  );
};

export const useLoginCredentials = () => {
  const context = useContext(LoginCredentialsContext);
  if (context === undefined) {
    throw new Error("useLoginCredentials must be used within a LoginCredentialsProvider");
  }
  return context;
};
